import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { Box, Button, Grid2, IconButton, TextField } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

export type WysslingExtraInputsFormType = {
  userGradients: number[];
};

interface WysslingExtraInputsFormInputsProps {
  canEdit: boolean;
}

export default function WysslingExtraInputsForm({ canEdit }: Readonly<WysslingExtraInputsFormInputsProps>) {
  const { t } = useTranslation();
  const { register, setValue, watch, formState: { errors } } = useFormContext<WysslingExtraInputsFormType>();

  let userGradients = watch("userGradients") || [];

  const addRow = () => setValue("userGradients", [...userGradients, 0]);

  const removeRow = (index: number) => {
    const updated = userGradients.filter((_, i) => i !== index);
    setValue("userGradients", updated);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Grid2 container spacing={2}>
        {userGradients.map((value, index) => (
          <Grid2 size={4} key={index}>
            <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
              <TextField
                label={`${t("calculations.methods.wyssling.hydraulic-gradient")} ${index + 1}`}
                type="number"
                required
                disabled={!canEdit}
                {...register(`userGradients.${index}`, {
                  valueAsNumber: true,
                  validate: (val) => val > 0 || t("calculations.methods.errors.required"),
                })}
                error={!!errors.userGradients?.[index]}
                helperText={errors.userGradients?.[index]?.message}
                fullWidth
              />

              {canEdit && userGradients.length > 1 && (
                <IconButton aria-label="delete" onClick={() => removeRow(index)} color="error">
                  <DeleteIcon />
                </IconButton>
              )}
            </Box>
          </Grid2>
        ))}
      </Grid2>
      
      {canEdit && (
        <Button startIcon={<AddIcon />} onClick={addRow} variant="outlined" sx={{ alignSelf: "flex-start" }}>
          {t("generic.add-row")}
        </Button>
      )}
    </Box>
  );
}
